import React from 'react';
import { ModuleBaseNameProps } from '@/types';
import InfoBlockTextElement, { InfoBlockTextElementModel } from './InfoBlockTextElement';
import InfoBlockStatsModule, { InfoBlockStatsModuleModel } from './InfoBlockStatsModule';

export type InfoSectionModel<T extends ModuleBaseNameProps> = {
  moduleName: 'StatsModule' | 'InfoBlockTextElement';
  props: T;
  className?: string;
};

const InfoSection = ({ moduleName, className, props }: InfoSectionModel<ModuleBaseNameProps>) => {
  if (moduleName === 'InfoBlockTextElement') {
    return <InfoBlockTextElement className={className} {...(props as InfoBlockTextElementModel)} />;
  } else {
    return <InfoBlockStatsModule className={className} {...(props as InfoBlockStatsModuleModel)} />;
  }
};

export default InfoSection;
